import { percentageDisplay } from '../displayFormatters'
import { EmployeeUtilization } from './dashboardApi'
import { DashboardFilters, hasDashboardFilters, noDashboardFilters } from './dashboardModel'

export const defaultEmployeeUtilization = (): EmployeeUtilization => ({
  crewMemberId: 1, name: 'A', email: null, totalHours: 0, billableHours: 0, unbillableHours: 0, unbillablePercent: null,
})

// The report exists to surface outliers: highest unbillable share first, people with no hours last.
export const sortByUnbillablePercent = (employees: EmployeeUtilization[]): EmployeeUtilization[] =>
  [...employees].sort((a, b) => {
    if (a.unbillablePercent === null && b.unbillablePercent === null) {
      return a.name.localeCompare(b.name)
    }
    if (a.unbillablePercent === null) {
      return 1
    }
    if (b.unbillablePercent === null) {
      return -1
    }
    return b.unbillablePercent - a.unbillablePercent || a.name.localeCompare(b.name)
  })

export const hoursDisplay = (hours: number): string => hours.toFixed(2)

// The percentage comes from the API, computed from unrounded hours; never recompute it here.
export const unbillablePercentDisplay = (percent: number | null): string =>
  percentageDisplay(percent) ?? '—'

export const hasTrackedTime = (employees: EmployeeUtilization[]): boolean =>
  employees.some(employee => employee.totalHours > 0)

// Time has no division or sales person, so of the report filters only the crew foreman applies.
export const utilizationFilters = (filters: DashboardFilters): DashboardFilters =>
  ({ ...noDashboardFilters, crewForemanEmails: filters.crewForemanEmails })

export const hasFiltersUtilizationIgnores = (filters: DashboardFilters): boolean =>
  hasDashboardFilters({ ...filters, crewForemanEmails: null })
